import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import ScrollToTopLink from "../../ScrollToTopLink";

const HomeNewsCards = ({ newsItem, formatDate }) => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "it").substring(0, 2);
  const title = lang === "en" ? newsItem.title_en : newsItem.title_it;
  const body = lang === "en" ? newsItem.body_en : newsItem.body_it;

  return (
    <div className="col-lg-4 reducewidth">
      <div className="blog-grid newscardhover">
        <div className="blog-img">
          <ScrollToTopLink to={`/news/${newsItem.id}`}>
            <img
              src={newsItem.img || "/img/homeBkg.jpg"}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "/img/homeBkg.jpg";
              }}
              title={title}
              alt={title}
              className="hoverzoom"
              width={"100%"}
              loading="lazy"
            />
          </ScrollToTopLink>
        </div>
        <div className="blog-info">
          <div className="blog-date-badge">
            <FontAwesomeIcon icon={faCalendar} className="blog-date-icon" />
            <span>{formatDate(newsItem.date)}</span>
          </div>
          <h5 className="text-capitalize">
            <ScrollToTopLink to={`/news/${newsItem.id}`}>
              {title}
            </ScrollToTopLink>
          </h5>
          {body && (
            <div className="blog-body-preview">{body.split(" ").slice(0, 20).join(" ") + "..."}</div>
          )}
          <div className="btn-bar">
            <ScrollToTopLink
              to={`/news/${newsItem.id}`}
              className="px-btn-arrow"
            >
              <span>{t("home.news_more_button")}</span>
              <i className="arrow"></i>
            </ScrollToTopLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeNewsCards;
